
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

/**
 * Recalculates vote statistics for a specific poll using existing functions
 * @param pollId The ID of the poll to recalculate
 * @returns A promise that resolves when the operation completes
 */
export const recalculatePollStatistics = async (pollId: string): Promise<void> => {
  try {
    console.log(`Recalculating statistics for poll: ${pollId}`);
    
    // Use the existing update_poll_options_counts function
    const { error } = await supabase.rpc('update_poll_options_counts', { poll_id: pollId });
    
    if (error) {
      throw error;
    }
    
    // Also update insight card stats if linked
    const { error: cardError } = await supabase.rpc('update_insight_card_stats', { input_poll_id: pollId });
    
    if (cardError) {
      console.warn('Failed to update linked card stats:', cardError);
      // Don't throw here as the main poll update succeeded
    }
    
    console.log(`Successfully recalculated statistics for poll: ${pollId}`);
  } catch (error) {
    console.error('Error recalculating poll statistics:', error);
    throw error;
  }
};

/**
 * Recalculates vote statistics for all linked cards using existing functions
 * @returns A promise that resolves when the operation completes
 */
export const recalculateAllLinkedCards = async (): Promise<void> => {
  try {
    console.log('Starting recalculation of all linked cards');
    
    // Use the existing recalculate_all_linked_cards function
    const { error } = await supabase.rpc('recalculate_all_linked_cards');
    
    if (error) {
      throw error;
    }
    
    toast.success('Successfully recalculated all poll votes and statistics');
    console.log('Recalculation completed successfully');
  } catch (error) {
    console.error('Error recalculating linked cards:', error);
    toast.error('Failed to recalculate poll statistics');
    throw error;
  }
};
